// extracted by mini-css-extract-plugin
module.exports = {"jds-CardTitle__link":"cardTitle_jds-CardTitle__link__joX8c","jds-CardTitle--big":"cardTitle_jds-CardTitle--big__tFhdl"};